import React, { useState, useRef, useEffect } from "react";
import NotSubscribe from "../Components/Base/Common/NotSubscribe";
import { brandTamaCoinService } from "../Services/brandTamaCoin.service";
import { getUserData } from "../Components/Constants/AppConstant";


export const BrandTamaCoin = ({
  cartItem,
  closeCartPanel,
  setAuth,
  setModal,
  user,
  NotifModul,
  profiles,
  setModalNotification,
  locationData,
  goToPricing,
}) => {
  const [notification, setNotification] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [hasClicked, setHasClicked] = useState(false);
  const isRequestInProgress = useRef(false);

  const handleNotifyMe = async () => {
    if (hasClicked) {
      setNotification("Already added! Please wait for our updates.");
      return;
    }

    if (isRequestInProgress.current) return;

    isRequestInProgress.current = true;
    setIsLoading(true);
    setHasClicked(true);
    setNotification("");
    const payload={
      email: getUserData().email,
    }
    
    try {
     const res = await brandTamaCoinService.subscribe(payload);
      if (res.status === 200) {
        setNotification("Success! You’ve subscribed to TamaCoin notifications.");
      }
    } catch (error) {
      const errorMessage =
        error.message || "Something went wrong. Please try again.";
      if (
        errorMessage.includes("already subscribed") ||
        errorMessage.includes("409")
      ) {
        setNotification("You're already subscribed to our notifications!");
      } else if (
        errorMessage.includes("authenticate") ||
        errorMessage.includes("401")
      ) {
        setNotification("Please authenticate to subscribe for notifications.");
      } else {
        setNotification(errorMessage);
      }
    } finally {
      setIsLoading(false);
      isRequestInProgress.current = false;
    }
  };
  

    useEffect(() => {
      getUserData().p_f_ids.includes(18);
    }, []);

  return (
    <>
      { getUserData().p_f_ids.includes(18)? (
        <>
          <div className="sm:h-screen md:h-[calc(100vh-195px)] lg:h-[calc(100vh-120px)] xl:h-[calc(100vh-120px)] 2xl:h-[calc(100vh-110px)] flex items-center justify-center bg-green-50 text-white">
            <div className="bg-gradient-to-br from-purple-900 via-indigo-900 to-black bg-white/5 border border-white/10 rounded-2xl p-8 max-w-md text-center shadow-[0_10px_25px_rgba(0,0,0,0.6)] backdrop-blur animate-fade-in">
              {/* Icon */}
              <div className="w-24 h-24 mx-auto mb-6 rounded-full bg-gradient-to-tr from-purple-400 to-pink-500 flex items-center justify-center text-3xl shadow-[0_0_20px_rgba(236,72,153,0.6)] animate-pop-in">
                ✨
              </div>

              {/* Title */}
              <h1 className="text-2xl font-bold mb-4">Tama Coin</h1>

              {/* Description */}
              <p className="text-gray-300 text-base mb-6">
                The creator coin designed for community, creators, and
                collectors. Stay tuned for the official launch!
              </p>

              {/* Coming Soon */}
              <div className="inline-flex items-center gap-2 text-purple-400 font-medium mb-6">
                ⏰ Coming Soon
              </div>

              {/* Button */}
              {!hasClicked && (
                <button
                  onClick={handleNotifyMe}
                  disabled={isLoading || hasClicked}
                  className="w-full py-3 rounded-xl text-lg font-bold bg-gradient-to-r from-purple-500 to-pink-500 hover:opacity-90  text-white transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed shadow-lg mb-4"
                >
                  {isLoading ? (
                    <span className="flex items-center justify-center">
                      <svg
                        className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                      >
                        <circle
                          className="opacity-25"
                          cx="12"
                          cy="12"
                          r="10"
                          stroke="currentColor"
                          strokeWidth="4"
                        ></circle>
                        <path
                          className="opacity-75"
                          fill="currentColor"
                          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                        ></path>
                      </svg>
                      Processing...
                    </span>
                  ) : hasClicked ? (
                    "Already Added"
                  ) : (
                    "Notify Me"
                  )}
                </button>
              )}
              {/* Notification */}
              {notification && (
                <div
                  className={`mt-4 p-3 rounded-lg border ${
                    notification.includes("Success")
                      ? "bg-purple-900/50 border-purple-400/30 text-emerald-200"
                      : notification.includes("already") ||
                        notification.includes("Already")
                      ? "bg-amber-900/50 border-amber-400/30 text-amber-200"
                      : "bg-red-900/50 border-red-400/30 text-red-200"
                  }`}
                >
                  {notification}
                </div>
              )}
            </div>
          </div>
        </>
      ): (
        <>
          <NotSubscribe
            goToPricing={goToPricing}
            type="brand"
            setAuth={setAuth}
            setModal={setModal}
            NotifModul={NotifModul}
            setNotifModul={setModalNotification}
            profiles={profiles}
            closeCartPanel={closeCartPanel}
            user={user}
            cartItem={cartItem}
            title={"Chat"}
            background={"background_inflist.png"}
          ></NotSubscribe>
        </>
      )}
    </>
  );
};
